<template>
	<div
		class="dialog-end-game"
		:class="content.bgColor">
		<h1 class="text-soft-cream">{{ content.text }}</h1>
		<app-button
			v-bind="content.btnBind"
			variant="rectangle"
			@click="$modal.close()">
			Start the game again
		</app-button>
	</div>
</template>

<script>
	import { ACTIVE_PLAYER } from '@/reference';

	export default {
		name: 'dialog-end-game',
		props: {
			winner: { type: String },
		},
		computed: {
			content() {
				switch (this.winner) {
					case ACTIVE_PLAYER.you.id:
						return {
							text: 'Congrats You Win!',
							bgColor: 'bg-deep-ocean-blue',
							btnBind: {
								bgColor: 'teal-tide',
								textColor: 'soft-cream',
							},
						};

					case ACTIVE_PLAYER.computer.id:
						return {
							text: 'Too bad, you lost!',
							bgColor: 'bg-sunset-coral',
							btnBind: {
								bgColor: 'coral-blush',
								textColor: 'sunset-coral',
							},
						};

					default:
						return {
							text: 'The game is a draw!!',
							bgColor: 'bg-black',
							btnBind: {
								bgColor: 'coral-blush',
								textColor: 'black',
							},
						};
				}
			},
		},
	};
</script>

<style lang="scss">
	.dialog-end-game {
		@extend %layout-flex-center-y;
		width: 100%;
		padding: 27px 16px;
		text-align: center;
	}
</style>
